export function trimHistoryToLimit(history, limit) {
  let totalChars = 0;
  const result = [];

  for (let i = history.length - 1; i >= 0; i--) {
    const msg = history[i];
    const msgLength = (msg.role + msg.content).length;

    if (totalChars + msgLength <= limit) {
      result.unshift(msg);
      totalChars += msgLength;
    } else {
      break;
    }
  }

  return result;
}

export const addMessageToHistory = (
  setConversationHistory,
  role,
  content,
  CHARACTER_LIMIT,
) => {
  setConversationHistory(prevHistory => {
    const updated = [...prevHistory, { role, content }];
    const trimmed = trimHistoryToLimit(updated, CHARACTER_LIMIT);
    localStorage.setItem('conversationHistory', JSON.stringify(trimmed));
    return trimmed;
  });
};

export function similarity(str1, str2) {
  const s1 = normalize(str1);
  const s2 = normalize(str2);

  const distance = levenshtein(s1, s2);
  const maxLen = Math.max(s1.length, s2.length);
  return maxLen === 0 ? 1 : 1 - distance / maxLen;
}

function normalize(str) {
    if (!str || typeof str !== "string") {
    return "";
  }

  return str.toLowerCase().replace(/_/g, ' ').replace(/\s+/g, ' ').trim();
}

function levenshtein(a, b) {
  const matrix = Array.from({ length: b.length + 1 }, (_, i) => [i]);
  for (let j = 0; j <= a.length; j++) matrix[0][j] = j;

  for (let i = 1; i <= b.length; i++) {
    for (let j = 1; j <= a.length; j++) {
      if (b.charAt(i - 1) === a.charAt(j - 1)) {
        matrix[i][j] = matrix[i - 1][j - 1];
      } else {
        matrix[i][j] = Math.min(
          matrix[i - 1][j - 1] + 1,
          matrix[i][j - 1] + 1,
          matrix[i - 1][j] + 1,
        );
      }
    }
  }
  return matrix[b.length][a.length];
}
